var map = {
	"./en/7-1/7_1tit.png": 51264,
	"./fi/7-1/7_1tit.png": 3926,
	"./in/7-1/7_1tit.png": 98348,
	"./th/7-1/7_1tit.png": 915,
	"./tw/7-1/7_1tit.png": 39002,
	"./zh/7-1/7_1tit.png": 72569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67724;